export default __webpack_public_path__ + "static/media/cliente06_color.098b669d.png";